import React, { useState } from 'react';
import { GlassCard } from '../components/GlassCard';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
interface ContactPageProps {
  isDark: boolean;
}
export function ContactPage({
  isDark
}: ContactPageProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => setIsSubmitting(false), 2000);
  };
  return <div className={`page-transition pt-32 pb-16 px-6 lg:px-8 max-w-7xl mx-auto ${isDark ? 'text-white' : ''}`} data-id="element-233">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-234">
        <div data-id="element-235">
          <h1 className={`text-4xl md:text-5xl font-bold mb-6 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-236">
            Get in Touch
          </h1>
          <p className={`text-xl mb-12 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-237">
            Ready to transform your business operations? Let's discuss how Akios
            can help you build brilliant.
          </p>

          <div className="space-y-8" data-id="element-238">
            <GlassCard className={`flex items-start gap-4 p-6 ${isDark ? 'bg-gray-800/50 border-gray-700' : ''}`} data-id="element-239">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${isDark ? 'bg-brand-900/50' : 'bg-brand-100'}`} data-id="element-240">
                <Mail className={`w-5 h-5 ${isDark ? 'text-brand-400' : 'text-brand-600'}`} data-id="element-241" />
              </div>
              <div data-id="element-242">
                <h3 className={`font-semibold mb-1 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-243">
                  Email Us
                </h3>
                <p className={isDark ? 'text-gray-300' : 'text-gray-600'} data-id="element-244">
                  hello@akios.com
                </p>
                <p className={isDark ? 'text-gray-300' : 'text-gray-600'} data-id="element-245">
                  support@akios.com
                </p>
              </div>
            </GlassCard>

            <GlassCard className={`flex items-start gap-4 p-6 ${isDark ? 'bg-gray-800/50 border-gray-700' : ''}`} data-id="element-246">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${isDark ? 'bg-brand-900/50' : 'bg-brand-100'}`} data-id="element-247">
                <Phone className={`w-5 h-5 ${isDark ? 'text-brand-400' : 'text-brand-600'}`} data-id="element-248" />
              </div>
              <div data-id="element-249">
                <h3 className={`font-semibold mb-1 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-250">
                  Call Us
                </h3>
                <p className={isDark ? 'text-gray-300' : 'text-gray-600'} data-id="element-251">
                  +91 82201 04955
                </p>
                <p className={`text-sm mt-1 ${isDark ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-252">
                  Mon-Fri, 9am-6pm IST
                </p>
              </div>
            </GlassCard>

            <GlassCard className={`flex items-start gap-4 p-6 ${isDark ? 'bg-gray-800/50 border-gray-700' : ''}`} data-id="element-253">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${isDark ? 'bg-brand-900/50' : 'bg-brand-100'}`} data-id="element-254">
                <MapPin className={`w-5 h-5 ${isDark ? 'text-brand-400' : 'text-brand-600'}`} data-id="element-255" />
              </div>
              <div data-id="element-256">
                <h3 className={`font-semibold mb-1 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-257">
                  India
                </h3>
                <p className={isDark ? 'text-gray-300' : 'text-gray-600'} data-id="element-258"></p>
                <p className={isDark ? 'text-gray-300' : 'text-gray-600'} data-id="element-259">
                  Chennai
                </p>
              </div>
            </GlassCard>
          </div>
        </div>

        <GlassCard className={`p-8 md:p-10 ${isDark ? 'bg-gray-800/50 border-gray-700' : ''}`} data-id="element-260">
          <h2 className={`text-2xl font-bold mb-6 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-261">
            Send us a message
          </h2>
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-262">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-263">
              <Input label="First Name" placeholder="Jane" required isDark={isDark} data-id="element-264" />
              <Input label="Last Name" placeholder="Doe" required isDark={isDark} data-id="element-265" />
            </div>
            <Input label="Email" type="email" placeholder="jane@company.com" required isDark={isDark} data-id="element-266" />
            <Input label="Company" placeholder="Company Ltd." isDark={isDark} data-id="element-267" />
            <Textarea label="Message" placeholder="Tell us about your project..." rows={4} required isDark={isDark} data-id="element-268" />

            <Button type="submit" className="w-full" size="lg" disabled={isSubmitting} data-id="element-269">
              {isSubmitting ? 'Sending...' : <>
                  Send Message
                  <Send className="ml-2 w-4 h-4" data-id="element-270" />
                </>}
            </Button>
          </form>
        </GlassCard>
      </div>
    </div>;
}